import { PresentationServeCardInterface } from '../../../Interfaces/PresentationServeCardInterface'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { Button, Icon } from '../../Elements'
import { Link } from 'react-router-dom'
import LoadingFit from '../Loading/LoadingFit'

const PresentationServeCard = ({
  serveTitle,
  effectiveDate,
  isDisable,
  isPresentation,
  canPresentation,
  description,
  onDelete,
  onPresentation,
  onPrice,
  onEdit,
  disableEvent,
}: PresentationServeCardInterface) => {
  return (
    <>
      <div
        className={`${isDisable
            ? ' opacity-60 before:absolute before:w-full before:h-full before:z-10  bg-white'
            : 'bg-white'
          } flex flex-col  bg-none p-1 relative shadow-inner`}
      >
        <div className='grid grid-cols-9 items-start border-b px-2 border-disable'>
          <div className='flex flex-col justify-center items-start gap-1.5 col-span-6 px-3  py-2'>
            <h2 className='text-primaryDark text-sm'>{serveTitle}</h2>
            <span className='text-xs text-primaryLight '>
              تاریخ موثر : {effectiveDate}
            </span>
            <span className='text-xs text-primaryLight'>
              وضعیت : {isPresentation ? 'ارائه شده' : 'ارائه نشده'}
            </span>
          </div>
          <div className='col-span-3 flex flex-col justify-between items-end h-full py-2'>
            <div className='flex  justify-end items-center gap-2'>
              <Button
                disabled={isPresentation}
                className='!bg-inherit !border-none !p-0'
              >
                <Icon
                  icon='rayteb-delete'
                  className='!text-2xl text-danger'
                  onClick={() => onDelete?.()}
                  disabled={disableEvent}
                />
              </Button>
              <Button
                className='!bg-inherit !border-none !p-0'
                disabled={disableEvent}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='h-7 w-7  text-warnDark'
                  onClick={() => onPrice?.()}
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </Button>
            </div>
            <Button
              disabled={isPresentation || disableEvent}
              className='!text-secondary !bg-none text-end !border-0 !text-xs 
            !font-bold  !w-full !bg-inherit !p-0'
              onClick={() => {
                onEdit?.()
              }}
            >
              مشاهده/ویرایش
            </Button>
          </div>
          <div className='text-xs text-primary font-bold py-2'>
            <p>{description}</p>
          </div>
        </div>
        <div className='flex py-2 justify-center items-center'>
          <Button
            disabled={isPresentation || disableEvent || canPresentation}
            onClick={() => onPresentation?.()}
            className='!bg-secondaryLight !border-secondary !shadow-xl !p-1 !px-10
             !text-white !text-sm'
          >
            ارائه
          </Button>
        </div>
      </div>
    </>
  )
}

export default PresentationServeCard
